export const SIDEMENUREDUCER =  (state = { open_keys: [], active_menu_item_key: [] }, action) => {
  switch(action.type){
    case 'SET_OPEN_KEYS':
      return {
        ...state,
        open_keys: action.data
      };
    case 'SET_ACTIVE_MENU_ITEM_KEY':
      return {
        ...state,
        active_menu_item_key: action.data
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/SideMenu/SidemenuReducer.js